import { render, staticRenderFns } from "./ContentFeedPinController.vue?vue&type=template&id=91affb48&"
import script from "./ContentFeedPinController.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedPinController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports